<template>
  <div id="login">

    <div class="row h-100 justify-content-center align-items-center">
      <div class="login-form forgot-password-form form">
        <h3 class="text-center brand">
          <img :src="config.logo.logo_icon_only" />
        </h3>

        <div class="form-group">
          <input type="text" readonly v-model="email" name="email" id="username" class="form-control" />
        </div>

        <div class="form-group">
          <input type="password" name="password" id="password" class="form-control rounded-0"
            :placeholder="i18n.app.common.password" v-model="password" />
        </div>

        <div class="form-group">
          <input type="password" name="password_confirmation" id="password_confirmation" class="form-control"
            :placeholder="i18n.app.common.confirm_password" v-model="passwordConfirm" />
        </div>

        <div class="form-group text-center">
          <button :disabled="state.loading" @click="onResetPasswordPress" class="btn btn-default"
            :class="state.loading && 'load-spinner'" type="button">
            <span>{{ i18n.app.components.login.reset_password }}</span>
          </button>
        </div>

        <div class="text-center footer-brand">
          <img :src="config.logo.logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapActions
  } from "vuex";
  import dialogMixin from "@/mixins/dialog.mixin";

  export default {
    data() {
      return {
        state: {},
        token: this.$route.query.token ?? "",
        email: this.$route.query.email ?? "",
        password: "",
        passwordConfirm: ""
      };
    },
    mixins: [dialogMixin],
    methods: {
      onResetPasswordPress() {
        this.state.loading = true;
        this._resetPassword({
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirm
        })
        .then(data => {
          this.$router.push({name: 'login'})
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => (this.state.loading = false));
      },
      ...mapActions({
        _resetPassword: "resetPassword",
      })
    }
  };

</script>
